import {useEffect, useState} from "react";

import TimerContext from "./timer-context";

const TimerProvider = ({ children }) => {
    const [seconds, setSeconds] = useState(900);

    useEffect(() => {
        let interval = null;
        if (seconds > 0) {
            interval = setInterval(() => {
                setSeconds(prevSeconds => {
                    if (prevSeconds <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prevSeconds - 1;
                });
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, []);

    return (
        <TimerContext.Provider value={{ seconds, isExpired: seconds <= 0 }}>
            {children}
        </TimerContext.Provider>
    );
};

export default TimerProvider;